import React from 'react';
import styled from 'styled-components';
import Comment from '@material-ui/icons/Comment';
import useCollection from '../hooks/useCollection';

export default function TotalCommentsTag({ proposalId }) {
  const { documents } = useCollection('comments', 'proposalId', proposalId);

  return (
    <Wrapper>
      <CommentIcon />
      <TotalComment>{documents ? Object.keys(documents).length : 0}</TotalComment>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  /* position: absolute;
  top: 5px;
  right: 15px; */
  background-color: rgb(3 83 151);
  padding: 5px;
  border-radius: 2px;
`;

const CommentIcon = styled(Comment)`
  width: 13px;
  height: 13px;
  margin-right: 3px;
  fill: white;
`;

const TotalComment = styled.p`
  margin: 0 0 -2px 0;
  color: white;
  line-height: 1;
  font-weight: 700;
`;
